import { FC } from 'react';

interface IProps {
    goldPoints: number;
    platinumPoints: number;
}

const LoyaltyGraphicResponsive: FC<IProps> = ({ goldPoints, platinumPoints }) => {
    return (
        <svg
            width="396"
            height="419"
            viewBox="0 0 396 419"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
                d="M197.414 298.253C158.517 355.627 109.589 394.307 48.1764 414.5H354.5V175.5H354.292C325.704 175.5 297.799 189.521 271.976 211.001C246.157 232.477 222.466 261.372 202.319 291.023C200.7 293.405 199.065 295.817 197.414 298.253Z"
                fill="#F5CC82"
                fillOpacity="0.2"
                stroke="#FFE9C0"
            />
            <path
                d="M122.502 338.285L122.492 338.299C112.491 353.16 101.254 369.857 88.4864 384.127C76.4628 397.565 63.0459 408.891 47.9743 414.5H199.5V295.5C170.954 295.54 143.399 307.242 123.371 336.994L122.502 338.285Z"
                fill="#F5CC82"
                fillOpacity="0.2"
                stroke="#FFE9C0"
            />
            <path
                d="M201.645 414.5H200.759C233.06 392.779 257.953 319.055 277.958 259.128C298.078 198.832 325.797 175.078 354.5 175V175.5M201.645 414.5C209.381 409.128 216.667 400.829 223.544 390.528C230.83 379.614 237.677 366.423 244.126 352.017C257.023 323.205 268.353 289.48 278.433 259.287L278.433 259.286C298.535 199.041 326.138 175.578 354.5 175.5M201.645 414.5C201.401 414.67 201.156 414.836 200.911 415H354.5V414.5M201.645 414.5H354.5M354.5 175.5V414.5M354.5 175.5C354.547 175.5 354.594 175.5 354.641 175.5H355V414.5H354.5"
                fill="#F5CC82"
                fillOpacity="0.2"
                stroke="#FFE9C0"
            />
            <line
                x1="355"
                y1="94.5"
                x2="355"
                y2="414.5"
                stroke="#DB9E2F"
                strokeLinecap="round"
                strokeDasharray="4 4"
            />
            <circle cx="355" cy="175" r="4" fill="#DB9E2F" />
            <path
                d="M374.799 108.799C385.734 97.8643 385.734 80.1357 374.799 69.201C363.864 58.2663 346.136 58.2663 335.201 69.201C324.266 80.1357 324.266 97.8643 335.201 108.799C346.136 119.734 363.864 119.734 374.799 108.799Z"
                fill="#F0F1F5"
            />
            <path
                d="M355.004 113.7C348.407 113.7 342.206 111.131 337.541 106.467C332.877 101.802 330.308 95.6005 330.308 89.0045C330.308 82.4085 332.877 76.2067 337.541 71.5422C342.206 66.8777 348.408 64.3086 355.004 64.3086C361.6 64.3086 367.801 66.8777 372.466 71.5422C377.13 76.2067 379.699 82.4085 379.699 89.0045C379.699 95.6005 377.13 101.802 372.466 106.467C367.801 111.131 361.6 113.7 355.004 113.7Z"
                fill="#ADB3C0"
            />
            <path
                d="M355.003 64.8184L355.351 65.5262L356.132 65.6395L355.568 66.19L355.701 66.9671L355.003 66.6001L354.305 66.9671L354.438 66.19L353.873 65.6395L354.654 65.5262L355.003 64.8184Z"
                fill="#F0F1F5"
            />
            <path
                d="M351.241 65.1113L351.697 65.7555L352.485 65.7452L352.013 66.3781L352.267 67.1243L351.52 66.8715L350.888 67.3434L350.898 66.5541L350.254 66.0991L351.007 65.865L351.241 65.1113Z"
                fill="#F0F1F5"
            />
            <path
                d="M347.574 65.9961L348.125 66.5607L348.903 66.4277L348.536 67.1262L348.903 67.8237L348.125 67.6907L347.574 68.2553L347.461 67.4754L346.754 67.1262L347.461 66.7769L347.574 65.9961Z"
                fill="#F0F1F5"
            />
            <path
                d="M344.087 67.4375L344.719 67.9084L345.466 67.6557L345.212 68.4028L345.684 69.0348L344.896 69.0245L344.44 69.6686L344.206 68.9159L343.452 68.6809L344.096 68.2258L344.087 67.4375Z"
                fill="#F0F1F5"
            />
            <path
                d="M340.869 69.4121L341.568 69.7791L342.265 69.4121L342.132 70.1892L342.697 70.7397L341.917 70.853L341.568 71.5608L341.218 70.853L340.438 70.7397L341.002 70.1892L340.869 69.4121Z"
                fill="#F0F1F5"
            />
            <path
                d="M337.999 71.8627L338.747 72.1164L339.379 71.6445L339.368 72.4329L340.012 72.8888L339.26 73.1229L339.026 73.8757L338.57 73.2315L337.781 73.2418L338.253 72.6098L337.999 71.8627Z"
                fill="#F0F1F5"
            />
            <path
                d="M335.55 74.7304L336.327 74.8634L336.877 74.2988L336.991 75.0797L337.699 75.4289L336.991 75.7781L336.877 76.558L336.327 75.9935L335.55 76.1264L335.917 75.4289L335.55 74.7304Z"
                fill="#F0F1F5"
            />
            <path
                d="M333.576 77.9483L334.365 77.9577L334.82 77.3145L335.055 78.0672L335.807 78.3013L335.163 78.7572L335.173 79.5456L334.541 79.0737L333.794 79.3274L334.047 78.5803L333.576 77.9483Z"
                fill="#F0F1F5"
            />
            <path
                d="M332.135 81.4374L332.916 81.3241L333.265 80.6172L333.614 81.3241L334.394 81.4374L333.829 81.9879L333.962 82.7659L333.265 82.3989L332.566 82.7659L332.699 81.9879L332.135 81.4374Z"
                fill="#F0F1F5"
            />
            <path
                d="M331.255 85.103L332.009 84.868L332.243 84.1152L332.698 84.7594L333.487 84.7491L333.015 85.3811L333.268 86.1282L332.522 85.8754L331.889 86.3464L331.899 85.558L331.255 85.103Z"
                fill="#F0F1F5"
            />
            <path
                d="M330.956 88.8644L331.663 88.5152L331.777 87.7344L332.328 88.2989L333.105 88.166L332.738 88.8644L333.105 89.562L332.328 89.429L331.777 89.9936L331.663 89.2137L330.956 88.8644Z"
                fill="#F0F1F5"
            />
            <path
                d="M331.255 92.6291L331.899 92.1731L331.889 91.3848L332.522 91.8566L333.268 91.6029L333.015 92.3501L333.487 92.982L332.698 92.9717L332.243 93.6159L332.009 92.8631L331.255 92.6291Z"
                fill="#F0F1F5"
            />
            <path
                d="M332.135 96.2954L332.699 95.7448L332.566 94.9668L333.265 95.3347L333.962 94.9668L333.829 95.7448L334.394 96.2954L333.614 96.4086L333.265 97.1165L332.916 96.4086L332.135 96.2954Z"
                fill="#F0F1F5"
            />
            <path
                d="M333.576 99.7838L334.047 99.1508L333.794 98.4046L334.541 98.6574L335.173 98.1855L335.163 98.9748L335.807 99.4298L335.055 99.6639L334.82 100.418L334.365 99.7735L333.576 99.7838Z"
                fill="#F0F1F5"
            />
            <path
                d="M335.55 103.003L335.917 102.306L335.55 101.607L336.327 101.74L336.877 101.176L336.991 101.957L337.699 102.306L336.991 102.654L336.877 103.435L336.327 102.87L335.55 103.003Z"
                fill="#F0F1F5"
            />
            <path
                d="M337.999 105.868L338.253 105.121L337.781 104.489L338.57 104.5L339.026 103.855L339.26 104.608L340.012 104.843L339.368 105.298L339.379 106.087L338.747 105.616L337.999 105.868Z"
                fill="#F0F1F5"
            />
            <path
                d="M340.869 108.321L341.002 107.543L340.438 106.992L341.218 106.879L341.568 106.172L341.917 106.879L342.697 106.992L342.132 107.543L342.265 108.321L341.568 107.954L340.869 108.321Z"
                fill="#F0F1F5"
            />
            <path
                d="M344.087 110.293L344.096 109.503L343.452 109.048L344.206 108.814L344.44 108.061L344.896 108.705L345.684 108.694L345.212 109.327L345.466 110.074L344.719 109.821L344.087 110.293Z"
                fill="#F0F1F5"
            />
            <path
                d="M347.574 111.738L347.461 110.957L346.754 110.609L347.461 110.259L347.574 109.479L348.125 110.043L348.903 109.91L348.536 110.609L348.903 111.306L348.125 111.173L347.574 111.738Z"
                fill="#F0F1F5"
            />
            <path
                d="M351.241 112.62L351.007 111.866L350.254 111.632L350.898 111.177L350.888 110.389L351.52 110.86L352.267 110.607L352.013 111.354L352.485 111.986L351.697 111.976L351.241 112.62Z"
                fill="#F0F1F5"
            />
            <path
                d="M355.003 112.914L354.654 112.207L353.873 112.094L354.438 111.544L354.305 110.766L355.003 111.133L355.701 110.766L355.568 111.544L356.132 112.094L355.351 112.207L355.003 112.914Z"
                fill="#F0F1F5"
            />
            <path
                d="M358.766 112.62L358.31 111.976L357.521 111.986L357.993 111.354L357.74 110.607L358.487 110.86L359.119 110.389L359.108 111.177L359.753 111.632L359 111.866L358.766 112.62Z"
                fill="#F0F1F5"
            />
            <path
                d="M362.433 111.738L361.883 111.173L361.104 111.306L361.472 110.609L361.104 109.91L361.883 110.043L362.433 109.479L362.546 110.259L363.254 110.609L362.546 110.957L362.433 111.738Z"
                fill="#F0F1F5"
            />
            <path
                d="M365.921 110.293L365.289 109.821L364.542 110.074L364.795 109.327L364.323 108.694L365.113 108.705L365.568 108.061L365.802 108.814L366.555 109.048L365.911 109.503L365.921 110.293Z"
                fill="#F0F1F5"
            />
            <path
                d="M369.142 108.321L368.445 107.954L367.746 108.321L367.879 107.543L367.314 106.992L368.095 106.879L368.445 106.172L368.793 106.879L369.574 106.992L369.009 107.543L369.142 108.321Z"
                fill="#F0F1F5"
            />
            <path
                d="M372.007 105.868L371.26 105.616L370.628 106.087L370.638 105.298L369.994 104.843L370.747 104.608L370.982 103.855L371.437 104.5L372.225 104.489L371.753 105.121L372.007 105.868Z"
                fill="#F0F1F5"
            />
            <path
                d="M374.463 103.003L373.685 102.87L373.135 103.435L373.021 102.654L372.314 102.306L373.021 101.957L373.135 101.176L373.685 101.74L374.463 101.607L374.096 102.306L374.463 103.003Z"
                fill="#F0F1F5"
            />
            <path
                d="M376.431 99.7838L375.642 99.7735L375.187 100.418L374.953 99.6639L374.199 99.4298L374.843 98.9748L374.833 98.1855L375.465 98.6574L376.212 98.4046L375.959 99.1508L376.431 99.7838Z"
                fill="#F0F1F5"
            />
            <path
                d="M377.876 96.2954L377.096 96.4086L376.746 97.1165L376.398 96.4086L375.617 96.2954L376.182 95.7448L376.049 94.9668L376.746 95.3347L377.445 94.9668L377.312 95.7448L377.876 96.2954Z"
                fill="#F0F1F5"
            />
            <path
                d="M378.758 92.6291L378.005 92.8631L377.771 93.6159L377.316 92.9717L376.526 92.982L376.998 92.3501L376.745 91.6029L377.493 91.8566L378.125 91.3848L378.114 92.1731L378.758 92.6291Z"
                fill="#F0F1F5"
            />
            <path
                d="M379.052 88.8644L378.345 89.2137L378.232 89.9936L377.68 89.429L376.903 89.562L377.27 88.8644L376.903 88.166L377.68 88.2989L378.232 87.7344L378.345 88.5152L379.052 88.8644Z"
                fill="#F0F1F5"
            />
            <path
                d="M378.758 85.103L378.114 85.558L378.125 86.3464L377.493 85.8754L376.745 86.1282L376.998 85.3811L376.526 84.7491L377.316 84.7594L377.771 84.1152L378.005 84.868L378.758 85.103Z"
                fill="#F0F1F5"
            />
            <path
                d="M377.876 81.4374L377.312 81.9879L377.445 82.7659L376.746 82.3989L376.049 82.7659L376.182 81.9879L375.617 81.4374L376.398 81.3241L376.746 80.6172L377.096 81.3241L377.876 81.4374Z"
                fill="#F0F1F5"
            />
            <path
                d="M376.431 77.9483L375.959 78.5803L376.212 79.3274L375.465 79.0737L374.833 79.5456L374.843 78.7572L374.199 78.3013L374.953 78.0672L375.187 77.3145L375.642 77.9577L376.431 77.9483Z"
                fill="#F0F1F5"
            />
            <path
                d="M374.463 74.7304L374.096 75.4289L374.463 76.1264L373.685 75.9935L373.135 76.558L373.021 75.7781L372.314 75.4289L373.021 75.0797L373.135 74.2988L373.685 74.8634L374.463 74.7304Z"
                fill="#F0F1F5"
            />
            <path
                d="M372.007 71.8627L371.753 72.6098L372.225 73.2418L371.437 73.2315L370.982 73.8757L370.747 73.1229L369.994 72.8888L370.638 72.4329L370.628 71.6445L371.26 72.1164L372.007 71.8627Z"
                fill="#F0F1F5"
            />
            <path
                d="M369.142 69.4121L369.009 70.1892L369.574 70.7397L368.793 70.853L368.445 71.5608L368.095 70.853L367.314 70.7397L367.879 70.1892L367.746 69.4121L368.445 69.7791L369.142 69.4121Z"
                fill="#F0F1F5"
            />
            <path
                d="M365.921 67.4375L365.911 68.2258L366.555 68.6809L365.802 68.9159L365.568 69.6686L365.113 69.0245L364.323 69.0348L364.795 68.4028L364.542 67.6557L365.289 67.9084L365.921 67.4375Z"
                fill="#F0F1F5"
            />
            <path
                d="M362.433 65.9961L362.546 66.7769L363.254 67.1262L362.546 67.4754L362.433 68.2553L361.883 67.6907L361.104 67.8237L361.472 67.1262L361.104 66.4277L361.883 66.5607L362.433 65.9961Z"
                fill="#F0F1F5"
            />
            <path
                d="M358.766 65.1113L359 65.865L359.753 66.0991L359.108 66.5541L359.119 67.3434L358.487 66.8715L357.74 67.1243L357.993 66.3781L357.521 65.7452L358.31 65.7555L358.766 65.1113Z"
                fill="#F0F1F5"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M360.481 84.1085C360.481 87.109 358.075 89.5149 355.072 89.5149C352.071 89.5149 349.664 87.109 349.664 84.1085C349.664 81.108 352.071 78.7031 355.072 78.7031C358.075 78.7031 360.481 81.108 360.481 84.1085ZM355.073 99.136C350.642 99.136 346.9 98.4157 346.9 95.6369C346.9 92.8571 350.665 92.1624 355.073 92.1624C359.506 92.1624 363.246 92.8826 363.246 95.6614C363.246 98.4412 359.481 99.136 355.073 99.136Z"
                fill="#F0F1F5"
            />
            <path
                d="M323.982 15.288C323.982 15.8853 323.838 16.4453 323.55 16.968C323.273 17.4907 322.83 17.912 322.222 18.232C321.625 18.552 320.868 18.712 319.95 18.712H318.078V23H315.838V11.832H319.95C320.814 11.832 321.55 11.9813 322.158 12.28C322.766 12.5787 323.22 12.9893 323.518 13.512C323.828 14.0347 323.982 14.6267 323.982 15.288ZM319.854 16.904C320.473 16.904 320.932 16.7653 321.23 16.488C321.529 16.2 321.678 15.8 321.678 15.288C321.678 14.2 321.07 13.656 319.854 13.656H318.078V16.904H319.854ZM327.813 21.224H331.493V23H325.573V11.832H327.813V21.224ZM339.765 20.872H335.317L334.581 23H332.229L336.245 11.816H338.853L342.869 23H340.501L339.765 20.872ZM339.157 19.08L337.541 14.408L335.924 19.08H339.157ZM351.97 11.832V13.64H348.994V23H346.754V13.64H343.778V11.832H351.97ZM355.844 11.832V23H353.604V11.832H355.844ZM367.609 23H365.369L360.297 15.336V23H358.057V11.816H360.297L365.369 19.496V11.816H367.609V23ZM372.031 11.832V18.744C372.031 19.5013 372.228 20.0827 372.623 20.488C373.017 20.8827 373.572 21.08 374.287 21.08C375.012 21.08 375.572 20.8827 375.967 20.488C376.361 20.0827 376.559 19.5013 376.559 18.744V11.832H378.815V18.728C378.815 19.6773 378.607 20.4827 378.191 21.144C377.785 21.7947 377.236 22.2853 376.543 22.616C375.86 22.9467 375.097 23.112 374.255 23.112C373.423 23.112 372.665 22.9467 371.983 22.616C371.311 22.2853 370.777 21.7947 370.383 21.144C369.988 20.4827 369.791 19.6773 369.791 18.728V11.832H372.031ZM393.155 11.832V23H390.915V15.736L387.923 23H386.227L383.219 15.736V23H380.979V11.832H383.523L387.075 20.136L390.627 11.832H393.155Z"
                fill="black"
            />
            <text x="79%" y="10.7%" fill="#333">
                600+ points
            </text>
            <path
                d="M218.799 227.799C229.734 216.864 229.734 199.136 218.799 188.201C207.864 177.266 190.136 177.266 179.201 188.201C168.266 199.136 168.266 216.864 179.201 227.799C190.136 238.734 207.864 238.734 218.799 227.799Z"
                fill="#FFEDA4"
            />
            <path
                d="M198.998 232.695C192.401 232.695 186.2 230.125 181.535 225.461C176.871 220.796 174.302 214.595 174.302 207.999C174.302 201.403 176.871 195.201 181.535 190.536C186.2 185.872 192.402 183.303 198.998 183.303C205.594 183.303 211.796 185.872 216.46 190.536C221.124 195.201 223.694 201.403 223.694 207.999C223.694 214.595 221.124 220.796 216.46 225.461C211.796 230.125 205.594 232.695 198.998 232.695Z"
                fill="#EFBF04"
            />
            <path
                d="M199.003 183.818L199.352 184.526L200.133 184.639L199.568 185.19L199.702 185.967L199.003 185.6L198.305 185.967L198.439 185.19L197.873 184.639L198.654 184.526L199.003 183.818Z"
                fill="#FFEDA4"
            />
            <path
                d="M195.242 184.111L195.697 184.755L196.486 184.745L196.014 185.378L196.268 186.124L195.521 185.872L194.888 186.343L194.898 185.554L194.254 185.099L195.008 184.865L195.242 184.111Z"
                fill="#FFEDA4"
            />
            <path
                d="M191.575 184.996L192.126 185.561L192.903 185.428L192.536 186.126L192.903 186.824L192.126 186.691L191.575 187.255L191.462 186.475L190.754 186.126L191.462 185.777L191.575 184.996Z"
                fill="#FFEDA4"
            />
            <path
                d="M188.086 186.438L188.718 186.908L189.465 186.656L189.212 187.403L189.683 188.035L188.895 188.024L188.44 188.669L188.205 187.916L187.452 187.681L188.096 187.226L188.086 186.438Z"
                fill="#FFEDA4"
            />
            <path
                d="M184.868 188.412L185.567 188.779L186.265 188.412L186.131 189.189L186.697 189.74L185.916 189.853L185.567 190.561L185.217 189.853L184.438 189.74L185.002 189.189L184.868 188.412Z"
                fill="#FFEDA4"
            />
            <path
                d="M182 190.863L182.747 191.116L183.379 190.645L183.369 191.433L184.013 191.889L183.26 192.123L183.026 192.876L182.571 192.232L181.781 192.242L182.253 191.61L182 190.863Z"
                fill="#FFEDA4"
            />
            <path
                d="M179.55 193.73L180.327 193.863L180.877 193.299L180.992 194.08L181.699 194.429L180.992 194.778L180.877 195.558L180.327 194.993L179.55 195.126L179.917 194.429L179.55 193.73Z"
                fill="#FFEDA4"
            />
            <path
                d="M177.576 196.948L178.365 196.958L178.82 196.314L179.055 197.067L179.808 197.301L179.164 197.757L179.173 198.546L178.541 198.074L177.794 198.327L178.048 197.58L177.576 196.948Z"
                fill="#FFEDA4"
            />
            <path
                d="M176.135 200.437L176.915 200.324L177.264 199.617L177.613 200.324L178.394 200.437L177.829 200.988L177.962 201.766L177.264 201.399L176.566 201.766L176.699 200.988L176.135 200.437Z"
                fill="#FFEDA4"
            />
            <path
                d="M175.255 204.103L176.008 203.868L176.242 203.115L176.698 203.759L177.486 203.749L177.014 204.381L177.268 205.128L176.521 204.875L175.889 205.346L175.899 204.558L175.255 204.103Z"
                fill="#FFEDA4"
            />
            <path
                d="M174.956 207.864L175.664 207.515L175.777 206.734L176.328 207.299L177.106 207.166L176.739 207.864L177.106 208.562L176.328 208.429L175.777 208.994L175.664 208.214L174.956 207.864Z"
                fill="#FFEDA4"
            />
            <path
                d="M175.255 211.629L175.899 211.173L175.889 210.385L176.521 210.857L177.268 210.603L177.014 211.35L177.486 211.982L176.698 211.972L176.242 212.616L176.008 211.863L175.255 211.629Z"
                fill="#FFEDA4"
            />
            <path
                d="M176.135 215.295L176.699 214.745L176.566 213.967L177.264 214.335L177.962 213.967L177.829 214.745L178.394 215.295L177.613 215.409L177.264 216.116L176.915 215.409L176.135 215.295Z"
                fill="#FFEDA4"
            />
            <path
                d="M177.576 218.784L178.048 218.151L177.794 217.405L178.541 217.657L179.173 217.186L179.164 217.975L179.808 218.43L179.055 218.664L178.82 219.418L178.365 218.773L177.576 218.784Z"
                fill="#FFEDA4"
            />
            <path
                d="M179.55 222.003L179.917 221.306L179.55 220.607L180.327 220.74L180.877 220.176L180.992 220.957L181.699 221.306L180.992 221.654L180.877 222.435L180.327 221.87L179.55 222.003Z"
                fill="#FFEDA4"
            />
            <path
                d="M182 224.868L182.253 224.121L181.781 223.489L182.571 223.5L183.026 222.855L183.26 223.608L184.013 223.843L183.369 224.298L183.379 225.087L182.747 224.616L182 224.868Z"
                fill="#FFEDA4"
            />
            <path
                d="M184.868 227.321L185.002 226.543L184.438 225.992L185.217 225.879L185.567 225.172L185.916 225.879L186.697 225.992L186.131 226.543L186.265 227.321L185.567 226.954L184.868 227.321Z"
                fill="#FFEDA4"
            />
            <path
                d="M188.086 229.293L188.096 228.503L187.452 228.048L188.205 227.814L188.44 227.061L188.895 227.705L189.683 227.694L189.212 228.327L189.465 229.074L188.718 228.821L188.086 229.293Z"
                fill="#FFEDA4"
            />
            <path
                d="M191.575 230.738L191.462 229.957L190.754 229.609L191.462 229.259L191.575 228.479L192.126 229.043L192.903 228.91L192.536 229.609L192.903 230.306L192.126 230.173L191.575 230.738Z"
                fill="#FFEDA4"
            />
            <path
                d="M195.242 231.62L195.008 230.866L194.254 230.632L194.898 230.177L194.888 229.389L195.521 229.86L196.268 229.607L196.014 230.354L196.486 230.986L195.697 230.976L195.242 231.62Z"
                fill="#FFEDA4"
            />
            <path
                d="M199.003 231.914L198.654 231.207L197.873 231.094L198.439 230.544L198.305 229.766L199.003 230.133L199.702 229.766L199.568 230.544L200.133 231.094L199.352 231.207L199.003 231.914Z"
                fill="#FFEDA4"
            />
            <path
                d="M202.766 231.62L202.311 230.976L201.521 230.986L201.993 230.354L201.741 229.607L202.488 229.86L203.12 229.389L203.109 230.177L203.754 230.632L203 230.866L202.766 231.62Z"
                fill="#FFEDA4"
            />
            <path
                d="M206.438 230.738L205.887 230.173L205.11 230.306L205.477 229.609L205.11 228.91L205.887 229.043L206.438 228.479L206.552 229.259L207.259 229.609L206.552 229.957L206.438 230.738Z"
                fill="#FFEDA4"
            />
            <path
                d="M209.921 229.293L209.289 228.821L208.541 229.074L208.795 228.327L208.323 227.694L209.112 227.705L209.568 227.061L209.802 227.814L210.554 228.048L209.91 228.503L209.921 229.293Z"
                fill="#FFEDA4"
            />
            <path
                d="M213.143 227.321L212.445 226.954L211.746 227.321L211.88 226.543L211.314 225.992L212.095 225.879L212.445 225.172L212.794 225.879L213.575 225.992L213.009 226.543L213.143 227.321Z"
                fill="#FFEDA4"
            />
            <path
                d="M216.008 224.868L215.261 224.616L214.628 225.087L214.638 224.298L213.994 223.843L214.748 223.608L214.982 222.855L215.437 223.5L216.226 223.489L215.754 224.121L216.008 224.868Z"
                fill="#FFEDA4"
            />
            <path
                d="M218.463 222.003L217.686 221.87L217.136 222.435L217.022 221.654L216.314 221.306L217.022 220.957L217.136 220.176L217.686 220.74L218.463 220.607L218.096 221.306L218.463 222.003Z"
                fill="#FFEDA4"
            />
            <path
                d="M220.43 218.784L219.642 218.773L219.186 219.418L218.952 218.664L218.199 218.43L218.843 217.975L218.833 217.186L219.465 217.657L220.212 217.405L219.958 218.151L220.43 218.784Z"
                fill="#FFEDA4"
            />
            <path
                d="M221.877 215.295L221.096 215.409L220.747 216.116L220.398 215.409L219.617 215.295L220.183 214.745L220.049 213.967L220.747 214.335L221.446 213.967L221.312 214.745L221.877 215.295Z"
                fill="#FFEDA4"
            />
            <path
                d="M222.757 211.629L222.005 211.863L221.771 212.616L221.315 211.972L220.526 211.982L220.998 211.35L220.745 210.603L221.492 210.857L222.124 210.385L222.114 211.173L222.757 211.629Z"
                fill="#FFEDA4"
            />
            <path
                d="M223.052 207.864L222.344 208.214L222.231 208.994L221.68 208.429L220.903 208.562L221.27 207.864L220.903 207.166L221.68 207.299L222.231 206.734L222.344 207.515L223.052 207.864Z"
                fill="#FFEDA4"
            />
            <path
                d="M222.757 204.103L222.114 204.558L222.124 205.346L221.492 204.875L220.745 205.128L220.998 204.381L220.526 203.749L221.315 203.759L221.771 203.115L222.005 203.868L222.757 204.103Z"
                fill="#FFEDA4"
            />
            <path
                d="M221.877 200.437L221.312 200.988L221.446 201.766L220.747 201.399L220.049 201.766L220.183 200.988L219.617 200.437L220.398 200.324L220.747 199.617L221.096 200.324L221.877 200.437Z"
                fill="#FFEDA4"
            />
            <path
                d="M220.43 196.948L219.958 197.58L220.212 198.327L219.465 198.074L218.833 198.546L218.843 197.757L218.199 197.301L218.952 197.067L219.186 196.314L219.642 196.958L220.43 196.948Z"
                fill="#FFEDA4"
            />
            <path
                d="M218.463 193.73L218.096 194.429L218.463 195.126L217.686 194.993L217.136 195.558L217.022 194.778L216.314 194.429L217.022 194.08L217.136 193.299L217.686 193.863L218.463 193.73Z"
                fill="#FFEDA4"
            />
            <path
                d="M216.008 190.863L215.754 191.61L216.226 192.242L215.437 192.232L214.982 192.876L214.748 192.123L213.994 191.889L214.638 191.433L214.628 190.645L215.261 191.116L216.008 190.863Z"
                fill="#FFEDA4"
            />
            <path
                d="M213.143 188.412L213.009 189.189L213.575 189.74L212.794 189.853L212.445 190.561L212.095 189.853L211.314 189.74L211.88 189.189L211.746 188.412L212.445 188.779L213.143 188.412Z"
                fill="#FFEDA4"
            />
            <path
                d="M209.921 186.438L209.91 187.226L210.554 187.681L209.802 187.916L209.568 188.669L209.112 188.024L208.323 188.035L208.795 187.403L208.541 186.656L209.289 186.908L209.921 186.438Z"
                fill="#FFEDA4"
            />
            <path
                d="M206.438 184.996L206.552 185.777L207.259 186.126L206.552 186.475L206.438 187.255L205.887 186.691L205.11 186.824L205.477 186.126L205.11 185.428L205.887 185.561L206.438 184.996Z"
                fill="#FFEDA4"
            />
            <path
                d="M202.766 184.111L203 184.865L203.754 185.099L203.109 185.554L203.12 186.343L202.488 185.872L201.741 186.124L201.993 185.378L201.521 184.745L202.311 184.755L202.766 184.111Z"
                fill="#FFEDA4"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M204.328 203.109C204.328 206.109 201.923 208.515 198.92 208.515C195.918 208.515 193.512 206.109 193.512 203.109C193.512 200.108 195.918 197.703 198.92 197.703C201.923 197.703 204.328 200.108 204.328 203.109ZM198.921 218.136C194.49 218.136 190.748 217.416 190.748 214.637C190.748 211.857 194.513 211.162 198.921 211.162C203.353 211.162 207.094 211.883 207.094 214.661C207.094 217.441 203.329 218.136 198.921 218.136Z"
                fill="#FFEDA4"
            />
            <line
                x1="200"
                y1="235.5"
                x2="200"
                y2="414.5"
                stroke="#DB9E2F"
                strokeLinecap="round"
                strokeDasharray="4 4"
            />
            <circle cx="200" cy="295" r="4" fill="#DB9E2F" />
            <path
                d="M187.552 132.192C187.296 131.723 186.944 131.365 186.496 131.12C186.048 130.875 185.525 130.752 184.928 130.752C184.267 130.752 183.68 130.901 183.168 131.2C182.656 131.499 182.256 131.925 181.968 132.48C181.68 133.035 181.536 133.675 181.536 134.4C181.536 135.147 181.68 135.797 181.968 136.352C182.267 136.907 182.677 137.333 183.2 137.632C183.723 137.931 184.331 138.08 185.024 138.08C185.877 138.08 186.576 137.856 187.12 137.408C187.664 136.949 188.021 136.315 188.192 135.504H184.352V133.792H190.4V135.744C190.251 136.523 189.931 137.243 189.44 137.904C188.949 138.565 188.315 139.099 187.536 139.504C186.768 139.899 185.904 140.096 184.944 140.096C183.867 140.096 182.891 139.856 182.016 139.376C181.152 138.885 180.469 138.208 179.968 137.344C179.477 136.48 179.232 135.499 179.232 134.4C179.232 133.301 179.477 132.32 179.968 131.456C180.469 130.581 181.152 129.904 182.016 129.424C182.891 128.933 183.861 128.688 184.928 128.688C186.187 128.688 187.28 128.997 188.208 129.616C189.136 130.224 189.776 131.083 190.128 132.192H187.552ZM197.241 140.112C196.196 140.112 195.236 139.867 194.361 139.376C193.486 138.885 192.793 138.208 192.281 137.344C191.769 136.469 191.513 135.483 191.513 134.384C191.513 133.296 191.769 132.32 192.281 131.456C192.793 130.581 193.486 129.899 194.361 129.408C195.236 128.917 196.196 128.672 197.241 128.672C198.297 128.672 199.257 128.917 200.121 129.408C200.996 129.899 201.684 130.581 202.185 131.456C202.697 132.32 202.953 133.296 202.953 134.384C202.953 135.483 202.697 136.469 202.185 137.344C201.684 138.208 200.996 138.885 200.121 139.376C199.246 139.867 198.286 140.112 197.241 140.112ZM197.241 138.112C197.913 138.112 198.505 137.963 199.017 137.664C199.529 137.355 199.929 136.917 200.217 136.352C200.505 135.787 200.649 135.131 200.649 134.384C200.649 133.637 200.505 132.987 200.217 132.432C199.929 131.867 199.529 131.435 199.017 131.136C198.505 130.837 197.913 130.688 197.241 130.688C196.569 130.688 195.972 130.837 195.449 131.136C194.937 131.435 194.537 131.867 194.249 132.432C193.961 132.987 193.817 133.637 193.817 134.384C193.817 135.131 193.961 135.787 194.249 136.352C194.537 136.917 194.937 137.355 195.449 137.664C195.972 137.963 196.569 138.112 197.241 138.112ZM206.86 138.224H210.54V140H204.62V128.832H206.86V138.224ZM215.867 128.832C217.041 128.832 218.07 129.061 218.955 129.52C219.851 129.979 220.539 130.635 221.019 131.488C221.51 132.331 221.755 133.312 221.755 134.432C221.755 135.552 221.51 136.533 221.019 137.376C220.539 138.208 219.851 138.853 218.955 139.312C218.07 139.771 217.041 140 215.867 140H211.963V128.832H215.867ZM215.787 138.096C216.961 138.096 217.867 137.776 218.507 137.136C219.147 136.496 219.467 135.595 219.467 134.432C219.467 133.269 219.147 132.363 218.507 131.712C217.867 131.051 216.961 130.72 215.787 130.72H214.203V138.096H215.787Z"
                fill="black"
            />
            <text x="37%" y="38.5%" fill="#333">
                {goldPoints} - {platinumPoints - 1} points
            </text>
            <path
                d="M65.799 347.799C76.7337 336.864 76.7337 319.136 65.799 308.201C54.8643 297.266 37.1357 297.266 26.201 308.201C15.2663 319.136 15.2663 336.864 26.201 347.799C37.1357 358.734 54.8643 358.734 65.799 347.799Z"
                fill="#F0EFEF"
            />
            <path
                d="M46.0035 352.7C39.4066 352.7 33.2057 350.131 28.5412 345.467C23.8767 340.802 21.3076 334.601 21.3076 328.005C21.3076 321.409 23.8767 315.207 28.5412 310.542C33.2057 305.878 39.4075 303.309 46.0035 303.309C52.5995 303.309 58.8014 305.878 63.4658 310.542C68.1303 315.207 70.6994 321.409 70.6994 328.005C70.6994 334.601 68.1303 340.802 63.4658 345.467C58.8014 350.131 52.5995 352.7 46.0035 352.7Z"
                fill="#CCCCCC"
            />
            <path
                d="M46.0031 303.818L46.3514 304.526L47.1323 304.639L46.5677 305.19L46.7006 305.967L46.0031 305.6L45.3047 305.967L45.4376 305.19L44.873 304.639L45.6539 304.526L46.0031 303.818Z"
                fill="#F0EFEF"
            />
            <path
                d="M42.2407 304.111L42.6967 304.755L43.485 304.745L43.0132 305.378L43.2669 306.124L42.5197 305.872L41.8878 306.343L41.898 305.554L41.2539 305.099L42.0067 304.865L42.2407 304.111Z"
                fill="#F0EFEF"
            />
            <path
                d="M38.5741 304.996L39.1246 305.561L39.9027 305.428L39.5356 306.126L39.9027 306.824L39.1246 306.691L38.5741 307.255L38.4608 306.475L37.7539 306.126L38.4608 305.777L38.5741 304.996Z"
                fill="#F0EFEF"
            />
            <path
                d="M35.0869 306.438L35.7189 306.908L36.466 306.656L36.2123 307.403L36.6842 308.035L35.8959 308.024L35.4399 308.669L35.2058 307.916L34.4521 307.681L35.0963 307.226L35.0869 306.438Z"
                fill="#F0EFEF"
            />
            <path
                d="M31.8691 308.412L32.5676 308.779L33.2651 308.412L33.1322 309.189L33.6967 309.74L32.9168 309.853L32.5676 310.561L32.2184 309.853L31.4375 309.74L32.0021 309.189L31.8691 308.412Z"
                fill="#F0EFEF"
            />
            <path
                d="M28.9994 310.863L29.7465 311.116L30.3785 310.645L30.3682 311.433L31.0124 311.889L30.2596 312.123L30.0256 312.876L29.5696 312.232L28.7812 312.242L29.2531 311.61L28.9994 310.863Z"
                fill="#F0EFEF"
            />
            <path
                d="M26.5498 313.73L27.3269 313.863L27.8774 313.299L27.9907 314.08L28.6985 314.429L27.9907 314.778L27.8774 315.558L27.3269 314.993L26.5498 315.126L26.9168 314.429L26.5498 313.73Z"
                fill="#F0EFEF"
            />
            <path
                d="M24.5762 316.948L25.3645 316.958L25.8195 316.314L26.0545 317.067L26.8073 317.301L26.1631 317.757L26.1734 318.546L25.5415 318.074L24.7943 318.327L25.0471 317.58L24.5762 316.948Z"
                fill="#F0EFEF"
            />
            <path
                d="M23.1348 320.437L23.9156 320.324L24.2648 319.617L24.6141 320.324L25.394 320.437L24.8294 320.988L24.9624 321.766L24.2648 321.399L23.5664 321.766L23.6993 320.988L23.1348 320.437Z"
                fill="#F0EFEF"
            />
            <path
                d="M22.2549 324.103L23.0086 323.868L23.2426 323.115L23.6977 323.759L24.487 323.749L24.0151 324.381L24.2679 325.128L23.5217 324.875L22.8887 325.346L22.899 324.558L22.2549 324.103Z"
                fill="#F0EFEF"
            />
            <path
                d="M21.9561 327.864L22.6629 327.515L22.7772 326.734L23.3277 327.299L24.1048 327.166L23.7378 327.864L24.1048 328.562L23.3277 328.429L22.7772 328.994L22.6629 328.214L21.9561 327.864Z"
                fill="#F0EFEF"
            />
            <path
                d="M22.2549 331.629L22.899 331.173L22.8887 330.385L23.5217 330.857L24.2679 330.603L24.0151 331.35L24.487 331.982L23.6977 331.972L23.2426 332.616L23.0086 331.863L22.2549 331.629Z"
                fill="#F0EFEF"
            />
            <path
                d="M23.1348 335.295L23.6993 334.745L23.5664 333.967L24.2648 334.335L24.9624 333.967L24.8294 334.745L25.394 335.295L24.6141 335.409L24.2648 336.116L23.9156 335.409L23.1348 335.295Z"
                fill="#F0EFEF"
            />
            <path
                d="M24.5762 338.784L25.0471 338.151L24.7943 337.405L25.5415 337.657L26.1734 337.186L26.1631 337.975L26.8073 338.43L26.0545 338.664L25.8195 339.418L25.3645 338.773L24.5762 338.784Z"
                fill="#F0EFEF"
            />
            <path
                d="M26.5498 342.003L26.9168 341.306L26.5498 340.607L27.3269 340.74L27.8774 340.176L27.9907 340.957L28.6985 341.306L27.9907 341.654L27.8774 342.435L27.3269 341.87L26.5498 342.003Z"
                fill="#F0EFEF"
            />
            <path
                d="M28.9994 344.868L29.2531 344.121L28.7812 343.489L29.5696 343.5L30.0256 342.855L30.2596 343.608L31.0124 343.843L30.3682 344.298L30.3785 345.087L29.7465 344.616L28.9994 344.868Z"
                fill="#F0EFEF"
            />
            <path
                d="M31.8691 347.321L32.0021 346.543L31.4375 345.992L32.2184 345.879L32.5676 345.172L32.9168 345.879L33.6967 345.992L33.1322 346.543L33.2651 347.321L32.5676 346.954L31.8691 347.321Z"
                fill="#F0EFEF"
            />
            <path
                d="M35.0869 349.293L35.0963 348.503L34.4521 348.048L35.2058 347.814L35.4399 347.061L35.8959 347.705L36.6842 347.694L36.2123 348.327L36.466 349.074L35.7189 348.821L35.0869 349.293Z"
                fill="#F0EFEF"
            />
            <path
                d="M38.5741 350.738L38.4608 349.957L37.7539 349.609L38.4608 349.259L38.5741 348.479L39.1246 349.043L39.9027 348.91L39.5356 349.609L39.9027 350.306L39.1246 350.173L38.5741 350.738Z"
                fill="#F0EFEF"
            />
            <path
                d="M42.2407 351.62L42.0067 350.866L41.2539 350.632L41.898 350.177L41.8878 349.389L42.5197 349.86L43.2669 349.607L43.0132 350.354L43.485 350.986L42.6967 350.976L42.2407 351.62Z"
                fill="#F0EFEF"
            />
            <path
                d="M46.0031 351.914L45.6539 351.207L44.873 351.094L45.4376 350.544L45.3047 349.766L46.0031 350.133L46.7006 349.766L46.5677 350.544L47.1323 351.094L46.3514 351.207L46.0031 351.914Z"
                fill="#F0EFEF"
            />
            <path
                d="M49.7658 351.62L49.3098 350.976L48.5215 350.986L48.9934 350.354L48.7396 349.607L49.4868 349.86L50.1188 349.389L50.1085 350.177L50.7526 350.632L49.9999 350.866L49.7658 351.62Z"
                fill="#F0EFEF"
            />
            <path
                d="M53.4331 350.738L52.8825 350.173L52.1045 350.306L52.4715 349.609L52.1045 348.91L52.8825 349.043L53.4331 348.479L53.5464 349.259L54.2542 349.609L53.5464 349.957L53.4331 350.738Z"
                fill="#F0EFEF"
            />
            <path
                d="M56.9214 349.293L56.2885 348.821L55.5423 349.074L55.7951 348.327L55.3232 347.694L56.1125 347.705L56.5675 347.061L56.8016 347.814L57.5553 348.048L56.9111 348.503L56.9214 349.293Z"
                fill="#F0EFEF"
            />
            <path
                d="M60.142 347.321L59.4445 346.954L58.7461 347.321L58.879 346.543L58.3145 345.992L59.0953 345.879L59.4445 345.172L59.7928 345.879L60.5737 345.992L60.0091 346.543L60.142 347.321Z"
                fill="#F0EFEF"
            />
            <path
                d="M63.0071 344.868L62.26 344.616L61.628 345.087L61.6383 344.298L60.9941 343.843L61.7469 343.608L61.9819 342.855L62.4369 343.5L63.2253 343.489L62.7534 344.121L63.0071 344.868Z"
                fill="#F0EFEF"
            />
            <path
                d="M65.4632 342.003L64.6852 341.87L64.1346 342.435L64.0213 341.654L63.3145 341.306L64.0213 340.957L64.1346 340.176L64.6852 340.74L65.4632 340.607L65.0962 341.306L65.4632 342.003Z"
                fill="#F0EFEF"
            />
            <path
                d="M67.4313 338.784L66.642 338.773L66.187 339.418L65.9529 338.664L65.1992 338.43L65.8434 337.975L65.8331 337.186L66.4651 337.657L67.2122 337.405L66.9594 338.151L67.4313 338.784Z"
                fill="#F0EFEF"
            />
            <path
                d="M68.8764 335.295L68.0956 335.409L67.7463 336.116L67.398 335.409L66.6172 335.295L67.1818 334.745L67.0488 333.967L67.7463 334.335L68.4448 333.967L68.3118 334.745L68.8764 335.295Z"
                fill="#F0EFEF"
            />
            <path
                d="M69.7584 331.629L69.0047 331.863L68.7707 332.616L68.3157 331.972L67.5264 331.982L67.9982 331.35L67.7455 330.603L68.4926 330.857L69.1246 330.385L69.1143 331.173L69.7584 331.629Z"
                fill="#F0EFEF"
            />
            <path
                d="M70.052 327.864L69.3452 328.214L69.2319 328.994L68.6804 328.429L67.9033 328.562L68.2704 327.864L67.9033 327.166L68.6804 327.299L69.2319 326.734L69.3452 327.515L70.052 327.864Z"
                fill="#F0EFEF"
            />
            <path
                d="M69.7584 324.103L69.1143 324.558L69.1246 325.346L68.4926 324.875L67.7455 325.128L67.9982 324.381L67.5264 323.749L68.3157 323.759L68.7707 323.115L69.0047 323.868L69.7584 324.103Z"
                fill="#F0EFEF"
            />
            <path
                d="M68.8764 320.437L68.3118 320.988L68.4448 321.766L67.7463 321.399L67.0488 321.766L67.1818 320.988L66.6172 320.437L67.398 320.324L67.7463 319.617L68.0956 320.324L68.8764 320.437Z"
                fill="#F0EFEF"
            />
            <path
                d="M67.4313 316.948L66.9594 317.58L67.2122 318.327L66.4651 318.074L65.8331 318.546L65.8434 317.757L65.1992 317.301L65.9529 317.067L66.187 316.314L66.642 316.958L67.4313 316.948Z"
                fill="#F0EFEF"
            />
            <path
                d="M65.4632 313.73L65.0962 314.429L65.4632 315.126L64.6852 314.993L64.1346 315.558L64.0213 314.778L63.3145 314.429L64.0213 314.08L64.1346 313.299L64.6852 313.863L65.4632 313.73Z"
                fill="#F0EFEF"
            />
            <path
                d="M63.0071 310.863L62.7534 311.61L63.2253 312.242L62.4369 312.232L61.9819 312.876L61.7469 312.123L60.9941 311.889L61.6383 311.433L61.628 310.645L62.26 311.116L63.0071 310.863Z"
                fill="#F0EFEF"
            />
            <path
                d="M60.142 308.412L60.0091 309.189L60.5737 309.74L59.7928 309.853L59.4445 310.561L59.0953 309.853L58.3145 309.74L58.879 309.189L58.7461 308.412L59.4445 308.779L60.142 308.412Z"
                fill="#F0EFEF"
            />
            <path
                d="M56.9214 306.438L56.9111 307.226L57.5553 307.681L56.8016 307.916L56.5675 308.669L56.1125 308.024L55.3232 308.035L55.7951 307.403L55.5423 306.656L56.2885 306.908L56.9214 306.438Z"
                fill="#F0EFEF"
            />
            <path
                d="M53.4331 304.996L53.5464 305.777L54.2542 306.126L53.5464 306.475L53.4331 307.255L52.8825 306.691L52.1045 306.824L52.4715 306.126L52.1045 305.428L52.8825 305.561L53.4331 304.996Z"
                fill="#F0EFEF"
            />
            <path
                d="M49.7658 304.111L49.9999 304.865L50.7526 305.099L50.1085 305.554L50.1188 306.343L49.4868 305.872L48.7396 306.124L48.9934 305.378L48.5215 304.745L49.3098 304.755L49.7658 304.111Z"
                fill="#F0EFEF"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M51.4808 323.109C51.4808 326.109 49.075 328.515 46.0724 328.515C43.0708 328.515 40.664 326.109 40.664 323.109C40.664 320.108 43.0708 317.703 46.0724 317.703C49.075 317.703 51.4808 320.108 51.4808 323.109ZM46.0733 338.136C41.6419 338.136 37.9004 337.416 37.9004 334.637C37.9004 331.857 41.6654 331.162 46.0733 331.162C50.5056 331.162 54.2461 331.883 54.2461 334.661C54.2461 337.441 50.4811 338.136 46.0733 338.136Z"
                fill="#F0EFEF"
            />
            <line
                x1="46"
                y1="355.5"
                x2="46"
                y2="414.5"
                stroke="#DB9E2F"
                strokeLinecap="round"
                strokeDasharray="4 4"
            />
            <circle cx="46" cy="414" r="4" fill="#DB9E2F" />
            <path
                d="M24.6163 260.112C23.8376 260.112 23.1336 259.979 22.5043 259.712C21.8856 259.445 21.3949 259.061 21.0323 258.56C20.6696 258.059 20.4829 257.467 20.4723 256.784H22.8723C22.9043 257.243 23.0643 257.605 23.3523 257.872C23.6509 258.139 24.0563 258.272 24.5683 258.272C25.0909 258.272 25.5016 258.149 25.8003 257.904C26.0989 257.648 26.2483 257.317 26.2483 256.912C26.2483 256.581 26.1469 256.309 25.9443 256.096C25.7416 255.883 25.4856 255.717 25.1763 255.6C24.8776 255.472 24.4616 255.333 23.9283 255.184C23.2029 254.971 22.6109 254.763 22.1523 254.56C21.7043 254.347 21.3149 254.032 20.9843 253.616C20.6643 253.189 20.5043 252.624 20.5043 251.92C20.5043 251.259 20.6696 250.683 21.0003 250.192C21.3309 249.701 21.7949 249.328 22.3923 249.072C22.9896 248.805 23.6723 248.672 24.4403 248.672C25.5923 248.672 26.5256 248.955 27.2403 249.52C27.9656 250.075 28.3656 250.853 28.4403 251.856H25.9763C25.9549 251.472 25.7896 251.157 25.4803 250.912C25.1816 250.656 24.7816 250.528 24.2803 250.528C23.8429 250.528 23.4909 250.64 23.2243 250.864C22.9683 251.088 22.8403 251.413 22.8403 251.84C22.8403 252.139 22.9363 252.389 23.1283 252.592C23.3309 252.784 23.5763 252.944 23.8643 253.072C24.1629 253.189 24.5789 253.328 25.1123 253.488C25.8376 253.701 26.4296 253.915 26.8883 254.128C27.3469 254.341 27.7416 254.661 28.0723 255.088C28.4029 255.515 28.5683 256.075 28.5683 256.768C28.5683 257.365 28.4136 257.92 28.1042 258.432C27.7949 258.944 27.3416 259.355 26.7443 259.664C26.1469 259.963 25.4376 260.112 24.6163 260.112ZM32.7503 248.832V260H30.5103V248.832H32.7503ZM37.2034 258.224H40.8834V260H34.9634V248.832H37.2034V258.224ZM52.3391 248.832L48.2431 260H45.5231L41.4271 248.832H43.8271L46.8991 257.712L49.9551 248.832H52.3391ZM55.9221 250.64V253.44H59.6821V255.216H55.9221V258.176H60.1621V260H53.6821V248.816H60.1621V250.64H55.9221ZM67.9578 260L65.4938 255.648H64.4378V260H62.1978V248.832H66.3898C67.2538 248.832 67.9898 248.987 68.5978 249.296C69.2058 249.595 69.6591 250.005 69.9578 250.528C70.2671 251.04 70.4218 251.616 70.4218 252.256C70.4218 252.992 70.2084 253.659 69.7818 254.256C69.3551 254.843 68.7204 255.248 67.8778 255.472L70.5498 260H67.9578ZM64.4378 253.968H66.3098C66.9178 253.968 67.3711 253.824 67.6698 253.536C67.9684 253.237 68.1178 252.827 68.1178 252.304C68.1178 251.792 67.9684 251.397 67.6698 251.12C67.3711 250.832 66.9178 250.688 66.3098 250.688H64.4378V253.968Z"
                fill="black"
            />
            <text x="0.2%" y="67.5%" fill="#333">
                0 - {goldPoints - 1} points
            </text>
        </svg>
    );
};

export default LoyaltyGraphicResponsive;
